import { render, staticRenderFns } from "./ThreatsDashboard.vue?vue&type=template&id=f9a4a54e"
import script from "./ThreatsDashboard.vue?vue&type=script&lang=js"
export * from "./ThreatsDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports